import { Honeybadger } from '@honeybadger-io/react';
import { Config } from './components/shared/utils/config';

const getLoggingEnv = () => {
    if (Config.Environment === 'local' || Config.Environment === 'dev') {
        return 'dev';
    } else if (Config.Environment === 'qa') {
        return 'qa';
    } else if (Config.Environment === 'prod') {
        return 'prod';
    } else {
        return 'dev';
    }
};

// NOTE: this can be updated later on when we use Grafana FARO to include more environments
const shouldReportData = (): boolean => {
    return getLoggingEnv() === 'qa' || getLoggingEnv() === 'prod';
};

const config = {
    apiKey: Config.HoneybadgerKey,
    environment: getLoggingEnv(),
    reportData: shouldReportData(),
    ignoreBrowserExtensionErrors: true,
};

export const honeybadger = Honeybadger.configure(config);

/*
 * Drop noise injected by third-party page software (browser extensions,
 * Office/Outlook Safe Links, antivirus). These rejections aren't thrown by our
 * code but bubble up through the page's promise handling, so their top stack
 * frame is our bundle and ignoreBrowserExtensionErrors can't catch them.
 */

const ignoredMessagePatterns = [/Object Not Found Matching Id/i];

honeybadger.beforeNotify((notice) => {
    if (notice && ignoredMessagePatterns.some((pattern) => pattern.test(notice.message))) {
        return false;
    }
});
